var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0H6C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48H43C46.3137 48 49 45.3137 49 42V6C49 2.68629 46.3137 0 43 0Z",
    fill: "#176B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.611 9.37501C21.7191 9.37778 18.8928 10.2379 16.4896 11.8466C14.0864 13.4553 12.214 15.7403 11.1093 18.413C10.0045 21.0856 9.71684 24.0257 10.2827 26.8618C10.8486 29.6978 12.2426 32.3024 14.2885 34.3464C16.3344 36.3903 18.9404 37.7818 21.777 38.345C24.6135 38.9082 27.5534 38.6177 30.225 37.5104C32.8965 36.4031 35.1798 34.5285 36.7862 32.1238C38.3926 29.719 39.25 26.892 39.25 24C39.2507 22.0781 38.8724 20.1748 38.1367 18.3993C37.4011 16.6237 36.3226 15.0105 34.963 13.6522C33.6033 12.2938 31.9891 11.2168 30.2128 10.4829C28.4365 9.74899 26.533 9.37251 24.611 9.37501ZM24.625 35.7C22.311 35.7 20.0489 35.0138 18.1248 33.7282C16.2008 32.4426 14.7012 30.6153 13.8156 28.4774C12.9301 26.3395 12.6984 23.987 13.1498 21.7175C13.6013 19.4479 14.7156 17.3631 16.3519 15.7269C17.9881 14.0906 20.0729 12.9763 22.3425 12.5248C24.612 12.0734 26.9645 12.3051 29.1024 13.1906C31.2403 14.0762 33.0676 15.5758 34.3532 17.4998C35.6388 19.4239 36.325 21.686 36.325 24C36.325 27.103 35.0923 30.079 32.8982 32.2732C30.704 34.4673 27.728 35.7 24.625 35.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3551 16.688H23.1621V25.463L30.8401 30.068L31.9401 28.268L25.3591 24.368L25.3551 16.688Z",
    fill: "#61CE65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListC);
export default __webpack_public_path__ + "static/media/list-c.57107a4ddab1732d70960622d66ef0f6.svg";
export { ForwardRef as ReactComponent };